import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class Experience extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    return (
      <div id="about">
        <FadeInSection>
        <br></br><br></br><br></br><br></br><br></br><br></br>
          <div style={{ fontSize: '29px', alignItems: "center" }} className="form-container">

            Sign up with your email to join our exclusive newsletter.
            <form onSubmit={this.handleSubmit} className="form">
              <input 
                type="email" 
                placeholder="Enter your email" 
                required 
                value={this.state.email} 
                onChange={this.handleEmailChange} 
                className="email-input"
              />
              <button type="submit" className="submit-button">Submit</button>
            </form>
          </div>
        

        </FadeInSection>
      </div>
    );
  }
}

export default Experience;
